import { combineReducers } from "redux";
import accountLockSlice from "../account-lock/accountLockSlice";
import aboutUsSlice from "./aboutUsSlice";
import accountSlice from "./accountSlice";
import activationSlice from "./activationSlice";
import bestFitSlice from "./bestFitSlice";
import billCalculatorSlice from "./billCalculatorSlice";
import billingSlice from "./billingSlice";
import checkoutSlice from "./checkoutSlice";
import componentSlice from "./componentSlice";
import contactUsSlice from "./contactUsSlice";
import coverageCheckSlice from "./coverageCheckSlice";
import devcieConfirmCheckSlice from "./deviceConfirmSlice";
import discoverSlice from "./discoverSlice";
import giveBackSlice from "./giveBackslice";
import globalValuesSlice from "./globalValuesSlice";
import helpSlice from "./helpSlice";
import homePageSlice from "./homePageSlice";
import imeiCompatibilitySlice from "./imeiCompatibilitySlice";
import ISPageSlice from "./ISPageSlice";
import landingPageSlice from "./landingPageSlice";
import manageCardSlice from "./manageCardSlice";
import MyAccountSlice from "./myAccountSlice";
import postActivationAccountSlice from "./postActivationAccountSlice";
import postActivationHomeSlice from "./postActivationHomeSlice";
import primaryValuesSlice from "./primaryValuesSlice";
import privacySlice from "./privacySlice";
import profileSlice from "./profileSlice";
import reviewsSlice from "./reviewsSlice";
import secondaryUserHomeSlice from "./secondaryUserHomeSlice";
import serviceSlice from "./serviceSlice";
import settingsSlice from "./settingsSlice";
import signinSlice from "./signinSlice";
import signupSlice from "./signupSlice";
import termSlice from "./termSlice";
import trackOrderSlice from "./trackOrderSlice";
import walletSlice from "./walletSlice";
import apnSettingsSlice from "./apnSettingsSlice";
import safeConnectionSlice from "./safeConnectionSlice";

const rootSlice = combineReducers({
  homepage: homePageSlice,
  bestfit: bestFitSlice,
  commonPage: componentSlice,
  aboutUs: aboutUsSlice,
  reviews: reviewsSlice,
  services: serviceSlice,
  terms: termSlice,
  privacy: privacySlice,
  giveBack: giveBackSlice,
  contactUsPage: contactUsSlice,
  PrimaryValues: primaryValuesSlice,
  signinPage: signinSlice,
  signupPage: signupSlice,
  coverageCheck: coverageCheckSlice,
  imeiCompatibilityPage: imeiCompatibilitySlice,
  ISPage: ISPageSlice,
  discover: discoverSlice,
  billCalculator: billCalculatorSlice,
  postActivation: postActivationHomeSlice,
  postActivationAccount: postActivationAccountSlice,
  help: helpSlice,
  profile: profileSlice,
  activation: activationSlice,
  trackOrder: trackOrderSlice,
  billing: billingSlice,
  checkout: checkoutSlice,
  myAccount: MyAccountSlice,
  manageCard: manageCardSlice,
  account: accountSlice,
  secondaryUserContent: secondaryUserHomeSlice,
  settings: settingsSlice,
  wallet: walletSlice,
  globalValues: globalValuesSlice,
  landingPage: landingPageSlice,
  deviceConfirmCheck: devcieConfirmCheckSlice,
  accountLockSlice: accountLockSlice,
  apnSettings: apnSettingsSlice,
  safeCon: safeConnectionSlice,
});

export default rootSlice;
